module.exports = __webpack_public_path__ + "static/media/Valvulas-Control-01.a325b813.jpg";